// extracted by mini-css-extract-plugin
module.exports = {"responsiveInputContainer":"frame-title-editable-text-input_responsiveInputContainer__XIelv"};